module.exports = __webpack_public_path__ + "static/media/back-to-top.c20a2985.svg";